import { render, staticRenderFns } from "./EventManager.vue?vue&type=template&id=7d49b877&scoped=true"
import script from "./EventManager.vue?vue&type=script&lang=js"
export * from "./EventManager.vue?vue&type=script&lang=js"
import style0 from "./EventManager.vue?vue&type=style&index=0&id=7d49b877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49b877",
  null
  
)

export default component.exports